import { injectGlobal, keyframes } from 'styled-components'

const down = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -60%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
`

injectGlobal`
  * {
    margin: 0;
    padding: 0;
    color: #282C34;
    font-family: 'NanumGothic';
    box-sizing: border-box;
  }

  html {
    width: 100%;
    height: 100%;

    #root {
      width: 100%;
      min-height: 100%;
    }
    body {
      width: 100%;
    }
  }
  
  a {
    text-decoration: none;
  }

  h1 {
    font-size: 24px;
    font-weight: 700;
  }

  input {
    outline: none;
  }

  button {
    border-radius: 0;
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  }

  strong {
    font-weight: 700;
  }

  table {
    border-collapse: collapse;
  }

  .Page {
    width: 100%;
    height: 100%;
    margin: 60px auto 100px auto !important;
    padding: 35px 0 0;
    font-size: 13px;
    box-sizing: border-box;
  }

  .PageTitle {
    height: 33px;
    color: #282C34;
    font-size: 25px;
    line-height: 26px;
    margin-bottom: 45px;
  }

  .Clearfix {
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  .ReactModal__Body--open {
    overflow: hidden;
  }

  .ReactModal__Overlay {
    z-index: 1500;
  }

  .ReactModal__Content {
    box-shadow: 1px 1px 10px 3px rgba(0, 0, 0, 0.5);
    animation: ${down} 800ms ease;
  }

  .Sortable--ghost {
    opacity: 0.5;
    
    div,
    input,
    button {
      background-color: #C8EBFB;
    }
  }

  .Center {
    text-align: center;
  }

  .Left {
    text-align: left;
  }

  .Total {
    height: 50px;
    padding: 0 !important;
    padding-left: 10px !important;
    color: #222 !important;
    font-size: 17px !important;
    text-align: left;
    font-weight: 700 !important;
    border: 1px solid #90A4AE;
    border-bottom: 0;
    background-color: #fff;
  }

  .Link {
    color: #36f;
    font-size: 13px;
    cursor: pointer;

    &:hover {
      color: #0039e6;
      text-decoration: underline;
    }
  }

  .Bold {
    font-weight: 700;
  }

  .Red {
    color: #ee4035;
  }

  .rc-slider-tooltip {
    white-space: pre;
  }
  .rc-slider-tooltip-arrow {
    display: none;
  }
  .rc-slider-tooltip-inner {
    padding: 6px 6px !important;
  }

  // 나눔고딕 ( 400 )
  @font-face {
    font-family: 'NanumGothic';
    font-style: normal;
    font-weight: 400;
    src: url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Regular.eot);
    src: url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Regular.eot?#iefix) format('embedded-opentype'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Regular.woff2) format('woff2'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Regular.woff) format('woff'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Regular.ttf) format('truetype');
  }
  // 나눔고딕 볼드 ( 700 )
  @font-face {
    font-family: 'NanumGothic';
    font-style: normal;
    font-weight: 700;
    src: url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Bold.eot);
    src: url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Bold.eot?#iefix) format('embedded-opentype'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Bold.woff2) format('woff2'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Bold.woff) format('woff'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-Bold.ttf) format('truetype');
  }
  // 나눔고딕 엑스트라 볼드 ( 800 )
  @font-face {
    font-family: 'NanumGothic';
    font-style: normal;
    font-weight: 800;
    src: url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-ExtraBold.eot);
    src: url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-ExtraBold.eot?#iefix) format('embedded-opentype'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-ExtraBold.woff2) format('woff2'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-ExtraBold.woff) format('woff'),
         url(//fonts.gstatic.com/ea/nanumgothic/v5/NanumGothic-ExtraBold.ttf) format('truetype');
  }
`


// WEBPACK FOOTER //
// ./client/globalStyled.js